import kotlin.math.abs
import kotlin.math.roundToInt

// Pure number helpers for the stats charts, kept free of Compose so they're unit tested.

/** Maps a touch x to the nearest data index across a plot inset by [edge] on both sides. */
internal fun chartIndexAt(x: Float, width: Float, edge: Float, lastIndex: Int): Int {
    if (lastIndex <= 0) return 0
    val usable = (width - edge * 2).coerceAtLeast(1f)
    val fraction = ((x - edge) / usable).coerceIn(0f, 1f)
    return (fraction * lastIndex).roundToInt()
}

/** Rounds [value] up to a clean axis maximum (…, 80, 100, 150, 200, 250, 300, 400, 500, 600, 800, 1000, …). */
internal fun niceCeiling(value: Int): Int {
    if (value <= 10) return 10
    var unit = 1
    while (unit * 100 < value) unit *= 10
    return NICE_STEPS.map { it * unit }.first { it >= value }
}

private val NICE_STEPS = listOf(10, 15, 20, 25, 30, 40, 50, 60, 80, 100)

internal fun formatAxisValue(value: Int): String =
    if (value >= 10_000) "${value / 1000}K" else value.toString()

/** A 0..1 share as a whole percent, e.g. 0.1666 → "17%". */
internal fun formatPercent(share: Double): String = "${(share * 100).roundToInt()}%"

/** One decimal place without platform formatting APIs, e.g. 6.25 → "6.3". */
internal fun formatOneDecimal(value: Double): String {
    val tenths = (value * 10).roundToInt()
    return "${tenths / 10}.${abs(tenths % 10)}"
}
